import React,{useEffect, useState} from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';


export default function Finereport()
{
    const[dlist,setDlist] = useState([]);
    const [date,setDate] = useState(new Date().toISOString().slice(0,10));
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const [userid,setUserid] =useState( parseInt(localStorage.getItem("userid")) );
    const[enddate,setEnddate]= useState(new Date().toISOString().slice(0,10));
    const [checked, setChecked] = useState(false);
    var i = 0;

    useEffect(()=>
    {
        if(checked === false)
        {
        fetch(API_URL+"api/Fine/GetFine?sdate="+date+"&edate="+enddate)
        .then(response => response.json())
        .then(data => {setDlist(data)})
        }
        else
        {
            fetch(API_URL+"api/Fine/GetFineByUser?sdate="+date+"&edate="+enddate +"&userid="+userid)
        .then(response => response.json())
        .then(data => {setDlist(data)});
        }
    })

    {/*function getfine(){
    
        fetch(API_URL+"api/Fine/GetFine?sdate="+document.getElementById('startdate').value +"&edate="+document.getElementById('enddate').value)
        .then(response => response.json())
    .then(data => {setDlist(data)})}*/}

    const Total = dlist.reduce((tot,el)=>tot+ el.FineAmount,0);
   
    return(
        <>
        <div className="reportheader"> 
            Fine Report
            <Navbar/>
        </div> 
        <div style={{backgroundColor:"lightskyblue",padding:"10px"}}>
        <label for="startdate" style={{marginTop:"10px"}}>Start Date</label>
        <input id="startdate" type="date" defaultValue = {date} style={{height:"30px",width:"150px",marginTop:"5px",marginLeft:"5px"}}></input><br/>
        <label for="enddate"  style={{marginTop:"10px",marginLeft:"8px"}}>End Date</label>
        <input id="enddate" type="date" defaultValue = {date} style={{height:"30px",width:"150px",marginTop:"5px",marginLeft:"5px"}}></input><br/>

        <label><input type="checkbox" id='byuser' style={{height:"18px",width:"18px"}} onChange={(e)=>{setChecked(!checked); checked ? document.getElementById('userid').disabled = true : document.getElementById('userid').disabled = false}}/>By</label><br/>
        <label for="userid" style={{marginTop:"10px",marginLeft:"5px"}}>UserID</label>

        <input id="userid" style={{height:"25px",width:"150px",marginTop:"5px",marginLeft:"25px"}} onChange={(e)=>{if(e.target.value !== ''){setUserid(e.target.value)}}} disabled></input>
        {/*<button type = "button"  className="fetchbutton" onClick={()=>{getfine()}}>Search</button>*/}
        </div>
        <table style={{width:"100%",marginTop:"10px",marginBottom:"40px"}}> 
            <th>S.No</th>
            <th>Date</th>
            <th>Loan No</th>
            <th>Amount</th>
            {dlist.length > 0 ? <>
            {dlist.map(fine =>{return(<tr>
            <td>{++i}</td>
            <td style={{textAlign:"center",width:"100px"}}>{fine.EntryDate.slice(8,10)}-{fine.EntryDate.slice(5,7)}-{fine.EntryDate.slice(0,4)}</td>
            <td>{fine.AccountNo}</td>
            <td>{fine.FineAmount}</td>
        </tr>)})}
        <tr>
            <td></td>
            <td></td>
            <td style ={{fontWeight:"bolder"}}>Total</td>
            <td style ={{fontWeight:"bolder"}}>{Total}</td>
            </tr></>:<></>}
        </table>
        <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}}>Back</button>
        </>)
}